import React from "react";
import CustomizationViewPublishButtons from "../helpers/CustomizationViewPublishButtons";
import { SectionHeaderWrapper } from "../../../../shared/SectionHeaderWrapper";

const ConfigurationFeaturesSettingsPage = () => {
  return (
    <SectionHeaderWrapper
      title="Features"
      subtitle="Customize what screens and features appear for your users in Merge Link"
      buttons={<CustomizationViewPublishButtons />}
    >
      <></>
    </SectionHeaderWrapper>
  );
};

export default ConfigurationFeaturesSettingsPage;
